import { GetterNames } from './keys'
import { WatchListState, WatchStatusTypes } from './types'
import { FlatAPIData, flattenJsonApiResponse } from '@/store/utils/converter'
import * as R from 'ramda'
import { WatchListAttributes } from '@/jsonapi/WatchList'

export type FlatWatchList = FlatAPIData<WatchListAttributes>

/* tslint:disable:no-shadowed-variable */
export const getters = {
  [GetterNames.watchLists]: (state: WatchListState): FlatWatchList[] => {
    return state.watchLists.map(flattenJsonApiResponse)
  },
  [GetterNames.uniqWatchListsByPatient]: (state: WatchListState, getters): FlatWatchList[] => {
    return R.uniqBy((watchList: FlatWatchList) => watchList.patientId, getters[GetterNames.watchLists]) // TODO fix type any
  },
  [GetterNames.watchingWatchLists]: (state: WatchListState, getters): FlatWatchList[] => {
    return getters[GetterNames.uniqWatchListsByPatient].filter(
      (watchList: FlatWatchList) => watchList.watchStatus !== WatchStatusTypes.UNWATCH
    )
  },
}
